import {Component, EventEmitter, Input, OnInit, Output} from "@angular/core";
import {CommonModule, NgIf} from "@angular/common";
import {IsfBillsPasteInForm} from "./isf.bills.pastein.form";
import {TemplateService} from "../../template.service";
import {IsfBillsListForm} from "./isf.bills.list.form";
import {CarrierBillDto, TemplateSubmisionRequest} from "../../../shipper";
import {BillSpinnerService} from "./bill.spinner.service";


@Component({
	selector: 'isf-bills',
	standalone: true,
	imports: [
		CommonModule,
		IsfBillsPasteInForm,
		IsfBillsListForm
	],
	template: `

		<div>
            <div id="spinner" *ngIf="spinner.visibility | async" class="spinner">
                <div class="lds-ripple"><div></div><div></div></div>
            </div>

            <div class="">
            
				<div *ngIf="enterBills">
                    <button class="btn btn-lg btn-secondary w-100" (click)="showPasteIn()">
                        <span></span> Enter Bills
                    </button>
                </div>
				
                <div *ngIf="showPasteInForm">
                    <isf-bills-pastein (onSubmit)="billsSubmit($event)" (onClear)="closePasteIn()"></isf-bills-pastein>
                </div>
                
				<div *ngIf="showList">
                    <isf-bills-list [carrierBills]="carrierBills" [(isf)]="isf" (onClear)="clear()"></isf-bills-list>
                </div>
            </div>
		</div>
	`,
	styleUrl:'isf.bills.css'
})
export class IsfBillsForm implements OnInit{
	
	@Input()
	isf!:TemplateSubmisionRequest;
	
	@Output()
	isfChange:EventEmitter<TemplateSubmisionRequest> = new EventEmitter();
	
	enterBills:boolean = false; //show button
	showPasteInForm:boolean = true;
	showList:boolean = false;
	
	carrierBills:CarrierBillDto[] = [];
	
	constructor(private service:TemplateService, public spinner:BillSpinnerService) {}
	
	
	ngOnInit(): void {
	
	}
	
	
	
	clear(){
		this.showPasteInForm = true;
		this.showList = false;
	}
	
	
	billsSubmit(bills:Array<string>){
		
		this.service.validateScacs(bills).subscribe((r) => {
			this.carrierBills = r;
			this.showPasteInForm = false;
			this.showList = true;
		});
	}
	
	
	showPasteIn(){
		this.showPasteInForm = true;
		this.enterBills = false;
	}
	
	closePasteIn(){
		this.showPasteInForm = false;
		this.enterBills = true;
	}
}
